import { PageConfigDT } from "@shared/components/page-config";
import { SITE_URL } from "@utils/constants";
import {
  imageObject,
  instructorItemListObject,
  itemPage,
  personObject,
} from "@utils/jsonLd";
import { InstructorDetail } from "@features/instructor/types";
import { useTranslations } from "next-intl";

const useInstructorConfig = (
  instructor: InstructorDetail | undefined,
  slug: string
) => {
  const t = useTranslations("meta");
  const url = SITE_URL + "/instructors/" + slug;

  const meta_title = instructor?.seo?.title || t("title");
  const meta = {
    title: meta_title,
    description: instructor?.seo?.description || t("desc"),
    keywords: instructor?.seo?.keywords,
    image: instructor?.photo,
  };

  const instructorPageStaticConfig = {
    jsonLd: instructor
      ? [
          personObject(instructor, slug),
          itemPage({
            url,
            imageUrl: instructor.photo,
            name: instructor.seo_title || instructor.name,
            mainContentSelector: ".instructorItemPageSelector",
          }),
          imageObject({
            caption: instructor.excerpt,
            contentUrl: instructor.photo,
            width: "100",
            height: "125",
            url,
            isPartOf: url,
          }),
          instructorItemListObject(instructor, url),
        ]
      : [],
    enableYektanet: false,
    enableHotjar: false,
  };

  const result: PageConfigDT = {
    ...instructorPageStaticConfig,
    meta: meta,
  };
  return result;
};

export default useInstructorConfig;
